var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    stroke: "#ECEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3341 21.1443H11.5877L9.52833 13.0565C9.43058 12.6844 9.22304 12.3555 8.91774 12.2005C8.15584 11.811 7.31628 11.5009 6.40039 11.3446V11.0332H10.8245C11.4351 11.0332 11.893 11.5009 11.9694 12.0442L13.0379 17.8782L15.7829 11.0332H18.4529L14.3341 21.1443ZM19.9794 21.1443H17.3857L19.5214 11.0332H22.1151L19.9794 21.1443ZM25.4707 13.8343C25.547 13.2897 26.0049 12.9783 26.5392 12.9783C27.3788 12.9001 28.2933 13.0565 29.0565 13.4447L29.5145 11.2677C28.7512 10.9564 27.9117 10.8 27.1498 10.8C24.6324 10.8 22.8007 12.2005 22.8007 14.1443C22.8007 15.623 24.0982 16.3995 25.0141 16.8672C26.0049 17.3336 26.3865 17.645 26.3102 18.1114C26.3102 18.811 25.547 19.1224 24.7851 19.1224C23.8692 19.1224 22.9533 18.8892 22.1151 18.4996L21.6571 20.6779C22.573 21.0661 23.5639 21.2225 24.4798 21.2225C27.3024 21.2993 29.0565 19.9001 29.0565 17.8C29.0565 15.1553 25.4707 15.0003 25.4707 13.8343ZM38.134 21.1443L36.0746 11.0332H33.8625C33.4046 11.0332 32.9466 11.3446 32.794 11.811L28.9805 21.1443H31.6505L32.1834 19.667H35.464L35.7693 21.1443H38.134ZM34.2439 13.7561L35.0058 17.5668H32.8701L34.2439 13.7561Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4beb29bbf872206bf0b91364d2cfcc5e.svg";
export { ForwardRef as ReactComponent };